import { useTranslation } from "react-i18next";
import ButtonIcon from "./buttonIcon";

const SelectDropdown = (props: any) => {
  const { t } = useTranslation();

  let value = props.value ?? "";
  let options = props.options ?? [];

  const updateValue = (valueSelect: any) => {
    props.handleChange(valueSelect);
  };

  return (
    <>
      <div
        className={`DatePickerInput mb-2 w-100 mt-0 ms-0 d-flex align-item-center justify-content-center input`}
      >
        <select
          value={value}
          onChange={(e) => updateValue(e.target.value)}
          className={`form-control Input showCharacters custom-select`}
        >
          <option value="">{t("select-option")}</option>
          {options.map((option: any, index: any) => (
            <option key={index} value={option.key}>
              {option.label}
            </option>
          ))}
        </select>
        <ButtonIcon icon="arrow_drop_down" />
      </div>
    </>
  );
};

export default SelectDropdown;
